// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "actioncable" + ".bundle-" + "caa5ea641d37a6ae4bab" + ".digested.js";
};